import { useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "@/pages/home/components/Navbar";
import Contact from "@/pages/home/components/Contact";
import HeroContactanos from "./components/HeroContactanos";
import LocationMap from "./components/LocationMap";
import QuoteModal from "@/components/feature/QuoteModal";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import LandingFooter from "@/components/feature/LandingFooter";
import LanguageTransitionWrapper from "@/components/feature/LanguageTransitionWrapper";

export default function ContactanosPage() {
  const { t } = useTranslation("common");
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteService, setQuoteService] = useState<string | undefined>(undefined);

  const openQuote = (service?: string) => {
    setQuoteService(service);
    setQuoteOpen(true);
  };
  const closeQuote = () => {
    setQuoteOpen(false);
    setTimeout(() => setQuoteService(undefined), 300);
  };

  return (
    <div className="relative bg-background-950 min-h-screen">
      <Navbar onOpenQuote={openQuote} />

      <LanguageTransitionWrapper>
        <main>
          <HeroContactanos onOpenQuote={openQuote} />
          <Contact />
          <LocationMap />
        </main>

        <LandingFooter pageName={t("nav.contact")} />
      </LanguageTransitionWrapper>

      <QuoteModal isOpen={quoteOpen} onClose={closeQuote} preselectedService={quoteService} />
      <WhatsAppFloat />
    </div>
  );
}